module.exports = __webpack_public_path__ + "static/media/incomplete-icon.919ca02b.svg";